<app-ad1 (stepChangeEvent)="changeStep($event)" [hidden]="!(step == 'step-1')"></app-ad1>
<app-ad2 (stepChangeEvent)="changeStep($event)" [hidden]="!(step == 'step-2')"></app-ad2>
<app-ad3 [(listingFor)]="listingFor" [(propertyType)]="propertyType"  (stepChangeEvent)="changeStep($event)" [hidden]="!(step == 'step-3')"></app-ad3>
<app-ad4 (stepChangeEvent)="changeStep($event)" [hidden]="!(step == 'step-4')"></app-ad4>
<app-ad5 (stepChangeEvent)="changeStep($event)" [hidden]="!(step == 'step-5')"></app-ad5>
<div class="ad-step1" *ngIf="step == 'final-step'">
    <div class="container">
        <div class="level-bar pt-5 pb-5">
            <div class="half-line level-bar-active"></div>
            <div class="level level-bar-active">1</div>
            <div class="full-line level-bar-active"></div>
            <div class="level level-bar-active">2</div>
            <div class="full-line level-bar-active"></div>
            <div class="level level-bar-active">3</div>
            <div class="full-line level-bar-active"></div>
            <div class="level level-bar-active">4</div>
            <div class="full-line level-bar-active"></div>
            <div class="level level-bar-active">5</div>
            <div class="full-line level-bar-active"></div>
            <div class="level level-bar-active"><img src="assets/check-white.png" style="width: 26px; height: auto" alt=""></div>
            <div class="full-line level-bar-active"></div>
        </div>
        <div class="level-text">
            All set!
        </div>
        <div class="page-contents fin" *ngIf="formSubmitted && ad">
            <div class="check-lg mt-5 mb-2">
                <img src="assets/check-white.png" alt="">
            </div>
            <div class="fin">
                <h1>You are all set up.</h1>
                <button [routerLink]="['/property/'+ad.id+'/payment']">Publish your ad</button> Redirecting to payment page in {{ count }}s.
            </div>
        </div>
        <div class="page-contents fin" *ngIf="formSubmitted && !ad">
            <div class="fin">
                <h1>Sorry! Something went wrong. Please try again.</h1>
                <button [routerLink]="['/add-property/step-1']">Try Again</button>
            </div>
        </div>
        <div class="page-contents fin" *ngIf="!formSubmitted">
            <div class="fin">
                <h1>We are setting up your Advertisement.</h1>
                <mat-spinner [diameter]="'70'" [color]="'warn'" class="mt-5"></mat-spinner>
            </div>
        </div>
    </div>
</div>